import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Habla.",
    kicker: "El comando",
    desc: "Dile a CHALANN lo que hay que hacer, igual que le dirías a tu ayudante de siempre. La IA de Gemini 3 Pro entiende el español mexicano — con sus modismos, marcas y medidas.",
    line: "\"cliente nuevo, cobra pan Bimbo grande y una Coca fría\"",
    color: "#f5f5f5",
  },
  {
    n: "02",
    title: "Vende.",
    kicker: "El ticket",
    desc: "El total aparece en pantalla al instante. Cobras en efectivo, con QR o tarjeta. Sin filas, sin capturar nada, sin errores de tecleo. El cliente ya se va.",
    line: "TOTAL $146.50 · Cambio $3.50 → Listo.",
    color: "#ff5a00",
  },
  {
    n: "03",
    title: "Cuenta.",
    kicker: "El inventario",
    desc: "Cada venta descuenta del inventario sola. Cuando algo se acaba, CHALANN te avisa. Pregúntale cuánto vendiste hoy sin abrir una sola app.",
    line: "\"¿cuántas Corona me quedan?\" → 47 medias · 12 megas.",
    color: "#ccff00",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifiesto"
      className="relative py-24 md:py-40 bg-[#050505]"
      data-testid="manifesto"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] tracking-[0.3em] text-white/40 uppercase">
              / Manifiesto
            </p>
          </div>
          <div className="md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]"
            >
              Un POS no debería <br className="hidden md:block" />
              <span className="italic text-white/40">frenar</span> tu tienda.
              <br />
              Debería <span className="text-[#ff5a00]">acompañarla</span>.
            </motion.h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {chapters.map((c, idx) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.9,
                delay: idx * 0.15,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="group relative rounded-2xl border border-white/10 bg-white/[0.02] hover:bg-white/[0.04] p-8 md:p-10 min-h-[420px] flex flex-col justify-between overflow-hidden"
              style={{ transitionProperty: "background-color, transform, border-color", transitionDuration: "500ms" }}
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div>
                <div className="flex items-baseline justify-between mb-8">
                  <span
                    className="font-display text-7xl md:text-8xl tracking-tighter leading-none"
                    style={{ color: c.color }}
                  >
                    {c.n}
                  </span>
                  <span className="font-mono text-[10px] tracking-[0.3em] text-white/40 uppercase">
                    {c.kicker}
                  </span>
                </div>
                <h3 className="font-display text-4xl md:text-5xl tracking-tighter mb-4" style={{ color: c.color }}>
                  {c.title}
                </h3>
                <p className="text-white/70 leading-relaxed text-[15px]">{c.desc}</p>
              </div>

              <div className="mt-8 pt-6 border-t border-white/10">
                <p className="font-mono text-xs md:text-sm text-white/60 leading-relaxed">
                  {c.line}
                </p>
              </div>

              <div
                className="absolute -bottom-24 -right-24 w-52 h-52 rounded-full opacity-0 group-hover:opacity-40 blur-3xl"
                style={{
                  backgroundColor: c.color,
                  transitionProperty: "opacity",
                  transitionDuration: "600ms",
                }}
              />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
